// extracted by mini-css-extract-plugin
export default {"button":"Button_button__G5GlC","buttonTransparent":"Button_buttonTransparent__cFW9Z","buttonSecondary":"Button_buttonSecondary__KWZ6V","smallbtn":"Button_smallbtn__IvICJ"};